import _ from 'lodash';
import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class CartaPorteClienteManager {

  static __values = {};

  static async boot()
  {
    let value = await Storage.get('catalogo.carta_porte_cliente');

    const params = {
      name: 'carta_porte',
      version: !!value ? value.version : '1.0',
      as: 'ui'
    }

    let response = {};

    try {
      response = await Http.get('/api/catalogos/cliente', { params });

      if (response.data.length > 0) {
        value = {
          'version': response.data[0].version,
          'data': response.data
        };

        await Storage.put('catalogo.carta_porte_cliente', value);
      }

      if (!!value) {
        for (const item of value.data) {
          CartaPorteClienteManager.__values[item.name] = item.values;
        }
      }
    } catch (error) {
      throw new Error('Los catálogos del cliente CartaPorte no están disponibles');
    }
  }

  static get(catalog, _default = []) {
    return _.get(CartaPorteClienteManager.__values, catalog, _default);
  }

  static all() {
    return CartaPorteClienteManager.__values;
  }
}

export default CartaPorteClienteManager;